import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import { fetchQueryData } from 'hooks/use-gremlin-query'
import { apiKeysQueryKeys } from 'queries/apikeys/query-keys'

import type { AxiosError } from 'axios'
import type { ApiKey } from 'types/api/api-key'

function fetchApiKeysAllForCompany({
  queryKey: [endpoint]
}: QueryFunctionContext<ReturnType<typeof apiKeysQueryKeys.getAllForCompany>>) {
  return fetchQueryData<ApiKey[]>(endpoint)
}

export function useGetApiKeysAllForCompany(
  options: QueryObserverOptions<ApiKey[], AxiosError> = {}
) {
  return useQuery<ApiKey[], AxiosError>({
    ...options,
    queryKey: apiKeysQueryKeys.getAllForCompany(),
    queryFn: fetchApiKeysAllForCompany
  })
}
